import { render } from "./uploading.vue?vue&type=template&id=5f28589a&scoped=true&ts=true"
import script from "./uploading.vue?vue&type=script&lang=ts"
export * from "./uploading.vue?vue&type=script&lang=ts"

import "./uploading.vue?vue&type=style&index=0&id=5f28589a&lang=scss&scoped=true"

import exportComponent from "D:\\alicode\\alicom-hall\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f28589a"]])

export default __exports__